import { ProductCardLayout } from "@~/types/types";
import { sendMonetateEvent } from "@~/utils/sendMonetateEvent";
import classNames from "classnames/bind";
import styles from "./Compact.module.scss";
import { Slot } from "../ProductCardSlot";

const cx = classNames.bind(styles);

export const slotNameMap = {
  IMAGE: "image",
  DETAILS: "details",
  MAIN: "main",
  FOOTER: "footer",
};

export const Compact: ProductCardLayout = (props) => {
  const { product } = props;

  return (
    <article
      onClick={() => {
        sendMonetateEvent("productCard.interaction");
      }}
      className={cx("card-container")}
      data-product-card-layout="Compact"
      data-testid="product-card-layout"
      data-product-id={product?.aliases?.pimProductId}
      ref={props.eventsRef}
    >
      <Slot
        slotName={slotNameMap["IMAGE"]}
        className={styles["image-slot"]}
        {...props}
      />
      <Slot
        slotName={slotNameMap["DETAILS"]}
        className={styles["details-slot"]}
        {...props}
      />
      <Slot
        slotName={slotNameMap["MAIN"]}
        className={styles["main-slot"]}
        {...props}
      />
      <Slot
        slotName={slotNameMap["FOOTER"]}
        className={styles["footer-slot"]}
        {...props}
      />
    </article>
  );
};
